import React, { useRef, useState } from 'react'

const UnshareModal = ({ unsharing, handleUnshare, cancel }) => {
  return <div id="confirm-modal" className={`modal ${ unsharing ? 'is-active' : ''}`}>
          <div className="modal-background"></div>
          <div className="modal-card">
            <header className="modal-card-head">
              <h1 className="modal-card-title">
                STOP SHARING LIST</h1>
              <button onClick={cancel} className="btn-icon-only icon-lg btn-close" aria-label="close">
                <span className="icon icon-close-large"></span><span className="sr-only">Close this
                  dialog</span>
              </button>
            </header>
            <section className="modal-card-body">
              <p>Are you sure you want to stop sharing this list? This will disable the share link that may have been sent to others, preventing them from accessing the list, and cannot be undone.</p>
            </section>
            <footer className="modal-card-foot">
              <div className="is-flex ml-auto">
                <button className="button" onClick={cancel} >Cancel</button>
                <button className="btn-solid is-danger" onClick={handleUnshare}>Stop Sharing</button>
              </div>
            </footer>
          </div>
        </div>
}

export default UnshareModal